import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  savedCount: 0,
  isAddedToSaved: false,
  isShowSavedTooltip: false,
};

export const savedPreferenceSlice = createSlice({
  name: "savedPreference",
  initialState,
  reducers: {
    setSavedCount: (state, action) => {
      state.savedCount = action.payload.count;
    },
    setIsAddedToSaved: (state, action) => {
      state.isAddedToSaved = !state.isAddedToSaved;
    },
    showSavedTooltip: (state, action) => {
      state.isShowSavedTooltip = action.payload;
    },
  },
});

export const { setSavedCount, setIsAddedToSaved, setOpenDrawer, showSavedTooltip } =
  savedPreferenceSlice.actions;
export default savedPreferenceSlice.reducer;
